<template>
    <div class="expertise">
        <transition appear
                v-on:before-enter="beforeEnterExpertiseContent"
                v-on:enter="enterExpertiseContent">
            <div class="expertise-content__container">
                <h2 class="expertise-content__heading">Expertise</h2>

                <ul class="expertise-content__page-counter-list">
                    <li class="expertise-content__page-counter-item">
                        <router-link class="expertise-content__page-counter-link" to="/work"></router-link>
                    </li>

                    <li class="expertise-content__page-counter-item">
                        <router-link class="expertise-content__page-counter-link" to="/culture"></router-link>
                    </li>

                    <li class="expertise-content__page-counter-item">
                        <router-link class="expertise-content__page-counter-link active" to="/expertise"></router-link>
                    </li>

                    <li class="expertise-content__page-counter-item">
                        <router-link class="expertise-content__page-counter-link" to="/news"></router-link>
                    </li>

                    <li class="expertise-content__page-counter-item">
                        <router-link class="expertise-content__page-counter-link" to="/contact"></router-link>
                    </li>
                </ul>

                <button class="expertise-content__cta" v-on:click="exploreClick">Explore</button>
            </div>
        </transition>

        <transition appear
            v-on:before-enter="beforeEnterExpertiseButtons"
            v-on:enter="enterExpertiseButtons">
            <ul class="expertise-btn-list">
                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button content updown">Content</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button design">Design</button>
                </li>
                
                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button digital updown">Digital</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button entertainment">Entertainment</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button experiential">Experiential</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button influencer updown">Influencer</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button insights">Insights</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button global updown">Global</button>
                </li> 

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button multicultural downup">Multicultural</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button partnerships updown">Partnerships</button>
                </li>
                
                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button pr">PR</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button purpose updown">Impact</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button social">Social</button>
                </li>

                <li class="expertise-btn-list__item">
                    <button class="expertise-btn-list__button strategy">Strategy</button>
                </li> 
            </ul>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavLeft"
                v-on:enter="enterSideNavLeft">
            <div class="expertise-side-nav__container--left">
                <router-link class="expertise-side-nav__link" to="/culture">
                    <h2 class="expertise-side-nav__heading">Culture</h2>

                    <ul class="expertise-side-nav__page-counter-list">
                        <li class="expertise-side-nav__page-counter-item"></li>

                        <li class="expertise-side-nav__page-counter-item active"></li>

                        <li class="expertise-side-nav__page-counter-item"></li>

                        <li class="expertise-side-nav__page-counter-item"></li>

                        <li class="expertise-side-nav__page-counter-item"></li>
                    </ul>
                </router-link>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavRight"
                v-on:enter="enterSideNavRight">
            <div class="expertise-side-nav__container--right">
                <router-link class="expertise-side-nav__link" to="/news">
                    <h2 class="expertise-side-nav__heading">News</h2>

                    <ul class="expertise-side-nav__page-counter-list">
                        <li class="expertise-side-nav__page-counter-item"></li>

                        <li class="expertise-side-nav__page-counter-item"></li>

                        <li class="expertise-side-nav__page-counter-item"></li>

                        <li class="expertise-side-nav__page-counter-item active"></li>

                        <li class="expertise-side-nav__page-counter-item"></li>
                    </ul>
                </router-link>
            </div>
        </transition>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .expertise {
        background: #003a4a url(/assets/imgs/Expertise-bg.png) center no-repeat;
        background-size: cover;
        color: #ffffff;
        height: 100vh;
        width: 100%;
        overflow: hidden;
        position: relative;

        &:after {
            content: "";
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 5;
            background: rgba(0, 58, 74, 0.5);
        }
    }

    .expertise-content__container {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%) scale(0.1);
        transform-origin: center center;
        transition: all 0.8s ease;
        z-index: 20;

        &.transform-anim {
            transform: translate(-50%, -50%) scale(1);
        }

        .expertise-content__heading {
            color: #ffffff;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 96px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0 0 20px;
            text-transform: uppercase;

            @media @breakpoint__tablet--large {
                font-size: 60px;
            }

            @media @breakpoint__mobile--large {
                font-size: 40px;
                margin: 0 0 10px;
            }
        }

        .expertise-content__cta {
            background-color: #e40046;
            border: none;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            display: inline-block;
            font-size: 16px;
            letter-spacing: 1px;
            padding: 10px 30px;
            text-decoration: none;
            z-index: 20;

            @media @breakpoint__tablet--small {
                font-size: 14px;
            }
        }

        .expertise-content__page-counter-list {
            margin: 0 0 25px;
            padding: 0;

            .expertise-content__page-counter-item {
                display: inline-block;
                margin: 0 8px;

                @media @breakpoint__mobile--large {
                    border-radius: 2px;
                    height: 8px;
                    margin: 0 5px;
                    width: 8px;
                }

                .expertise-content__page-counter-link {
                    background: #cccccd;
                    border-radius: 3px;
                    display: block;
                    z-index: 1;
                    height: 12px;
                    width: 12px;

                    @media @breakpoint__mobile--large {
                        border-radius: 2px;
                        height: 8px;
                        width: 8px;
                    }

                    &.active {
                        background: #e40046;
                    }
                }
            }
        }
    }

    .expertise-btn-list {
        position: absolute;
        left: 50%;
        list-style-type: none;
        padding: 0;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;

        @media @breakpoint__tablet--large {
            top: 50%;
        }
    }

    @keyframes MoveUpDown {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-20%);
        }
    }

    .expertise-btn-list__button {
        background: #003a4a;
        border: 1px solid #fff;
        border-radius: 5px; 
        color:#fff;
        cursor: default;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 15px;
        letter-spacing: 1.4px;
        line-height: 1;
        padding: 4px 12px 4px 12px;
        position: absolute;
        text-transform: uppercase; 
        transform: scale(0);
        transform-origin: center center;
        z-index: 8;

        @media @breakpoint__tablet--small {
            font-size: 14px;
            padding: 4px 6px;
        }

        @media @breakpoint__mobile--large {
            font-size: 13px;
            padding: 3px 6px;
        }

        &.updown-anim {
            animation: MoveUpDown 2s linear infinite;
        }

        &.content {
            left: -150px;
            top: 200px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                top: 0;
                transform: rotate(-103deg);
                position: absolute;
                width: 250px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-94deg);
                    width: 280px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-97deg);
                    width: 255px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -150px;
                top: 230px;
            }

            @media @breakpoint__tablet--small {
                left: -110px;
                top: 205px;
            }

            @media @breakpoint__mobile--large {
                left: -85px;
                top: 190px;
            }
        }
        
        &.design {
            left: -90px;
            top: 120px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 30%;
                top: 0;
                transform: rotate(-114deg);
                position: absolute;
                width: 175px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-105deg);
                    width: 172px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-111deg);
                    width: 175px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -80px;
                top: 120px;
            }

            @media @breakpoint__tablet--small {
                left: -40px;
                top: 115px;
            }

            @media @breakpoint__mobile--large {
                left: -30px;
                top: 100px;
            }
        }
        
        &.digital {
            left: -260px;
            top: 135px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                top: 0;
                transform: rotate(-85deg);
                position: absolute;
                width: 170px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-82deg);
                    width: 187px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-89deg);
                    width: 195px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -230px;
                top: 140px;
            }

            @media @breakpoint__tablet--small {
                left: -160px;
                top: 150px;
            }

            @media @breakpoint__mobile--large {
                left: -125px;
                top: 130px;
            }
        }
        
        &.entertainment {
            left: 140px;
            top: -250px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(105deg);
                position: absolute;
                width: 145px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(95deg);
                    width: 170px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(120deg);
                    width: 190px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 80px;
                top: -270px;
            }

            @media @breakpoint__tablet--small {
                left: 40px;
                top: -265px;
            }

            @media @breakpoint__mobile--large {
                left: 10px;
                top: -210px;
            }
        }
        
        &.experiential {
            left: -70px;
            top: -275px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(88deg);
                position: absolute;
                width: 165px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(78deg);
                    width: 163px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(96deg);
                    width: 150px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -140px;
                top: -260px;
            }

            @media @breakpoint__tablet--small {
                left: -125px;
                top: -250px;
            }

            @media @breakpoint__mobile--large {
                left: -135px;
                top: -220px;
            }
        }
        
        &.global {
            left: 220px;
            top: 40px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                top: 0;
                transform: rotate(-100deg);
                position: absolute;
                width: 75px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-116deg);
                    width: 129px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-97deg);
                    width: 138px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 170px;
                top: 70px;
            }

            @media @breakpoint__tablet--small {
                left: 135px;
                top: 90px;
            }

            @media @breakpoint__mobile--large {
                left: 65px;
                top: 80px;
            }
        }
        
        &.influencer {
            left: 50px;
            top: -180px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(85deg);
                position: absolute;
                width: 100px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(123deg);
                    width: 124px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(112deg);
                    width: 100px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 50px;
                top: -205px;
            }

            @media @breakpoint__tablet--small {
                left: 60px;
                top: -195px;
            }

            @media @breakpoint__mobile--large {
                left: 40px;
                top: -120px;
            }
        }
        
        &.insights {
            left: 60px;
            top: 210px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 40%;
                top: 0;
                transform: rotate(-86deg);
                position: absolute;
                width: 265px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    left: 50%;
                    transform: rotate(-92deg);
                    width: 286px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-92deg);
                    width: 255px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 60px;
                top: 240px;
            }

            @media @breakpoint__tablet--small {
                left: 10px;
                top: 205px;
            }

            @media @breakpoint__mobile--large {
                left: 45px;
                top: 200px;
            }
        }
        
        &.multicultural {
            left: 140px;
            top: 130px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 40%;
                top: 0;
                transform: rotate(-102deg);
                position: absolute;
                width: 170px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-89deg);
                    width: 195px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-90deg);
                    width: 195px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 70px;
                top: 150px;
            }

            @media @breakpoint__tablet--small {
                left: 60px;
                top: 150px;
            }

            @media @breakpoint__mobile--large {
                left: 10px;
                top: 145px;
            }
        }

        &.partnerships {
            left: -160px;
            top: -210px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(75deg);
                position: absolute;
                width: 135px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    width: 74px;
                }

                @media @breakpoint__tablet--small {
                    width: 83px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -160px;
                top: -170px;
            }

            @media @breakpoint__tablet--small {
                left: -110px;
                top: -180px;
            }

            @media @breakpoint__mobile--large {
                left: -140px;
                top: -120px;
            }
        }

        &.pr {
            left: -250px;
            top: -260px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(78deg);
                position: absolute;
                width: 147px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(47deg);
                    width: 190px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(62deg);
                    width: 132px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -275px;
                top: -235px;
            }

            @media @breakpoint__tablet--small {
                left: -200px;
                top: -215px;
            }

            @media @breakpoint__mobile--large {
                left: -130px;
                top: -175px;
            }
        }
        
        &.purpose {
            left: -330px;
            top: -185px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(75deg);
                position: absolute;
                width: 65px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(25deg);
                    width: 87px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(72deg);
                    width: 45px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -290px;
                top: -135px;
            }

            @media @breakpoint__tablet--small {
                left: -220px;
                top: -140px;
            }

            @media @breakpoint__mobile--large {
                left: -65px;
                top: -165px;
            }
        }

        &.social {
            left: -335px;
            top: 55px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                top: 0;
                transform: rotate(-70deg);
                position: absolute;
                width: 90px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-56deg);
                    width: 135px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-83deg);
                    width: 147px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -280px;
                top: 60px;
            }

            @media @breakpoint__tablet--small {
                left: -215px;
                top: 100px;
            }

            @media @breakpoint__mobile--large {
                left: -135px;
                top: 75px;
            }
        }
        
        &.strategy {
            left: 230px;
            top: -170px;

            &:after {
                border-bottom: solid 1px rgba(255, 255, 255, 0.11);
                content: "";
                height: 1px;
                left: 50%;
                bottom: 0;
                transform: rotate(115deg);
                position: absolute;
                width: 70px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(149deg);
                    width: 97px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(105deg);
                    width: 42px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 180px;
                top: -145px;
            }

            @media @breakpoint__tablet--small {
                left: 115px;
                top: -140px;
            }

            @media @breakpoint__mobile--large {
                left: 52px;
                top: -160px;
            }
        }
    }
    
    .expertise-btns {
        position:relative;
        width:100%; 
        height:100%;
        z-index: 10
    }

    .expertise-btns .title-div {
        position:relative;
        top:50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .expertise-btn {
        position:absolute;
        left:45%;
        top:45%;
        padding:2px 12px 3px 12px;
        color:#fff;
        font-size:1.1em;
        letter-spacing:1.4px;
        text-transform:uppercase; 
        border:1px solid #fff;
        border-radius:5px; 
        background:#003a4a; cursor:default;
        animation-duration: 4s;
        animation-iteration-count: infinite;
        transition-timing-function: ease-in-out;
    }
    
    button.expertise.ov {
        -webkit-animation-name:jiggleUp; animation-name:jiggleUp;
    }

    button.expertise.un {
        -webkit-animation-name:jiggleDn; 
        animation-name:jiggleDn;
    }

    .expertise-side-nav__link {
        text-decoration: none;
    }

    .expertise-side-nav__container {
        position: absolute;
        text-align: right;
        top: 52%;
        transform: translate(0, -50%);
        z-index: 15;

        .expertise-side-nav__heading {
            color: #dfe6e8;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 28px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0;
            opacity: 0.8;
            text-transform: uppercase;

            @media @breakpoint__tablet--small {
                font-size: 20px;
            }

            @media @breakpoint__mobile--large {
                font-size: 14px;
            }
        }

        .expertise-side-nav__page-counter-list {
            margin:0;
            padding: 0;

            .expertise-side-nav__page-counter-item {
                background: #cccccd;
                border-radius: 1.5px;
                display: inline-block;
                height: 5px;
                margin: 0 3px;
                width: 5px;
                z-index: 1;

                &.active {
                    background: #e40046;
                }
            }
        }

        @media @breakpoint__mobile--large {
             display: none;
         }
    }

    .expertise-side-nav__container--left {
        .expertise-side-nav__container();
        left: 12px;
        text-align: left;
    }

    .expertise-side-nav__container--right {
        .expertise-side-nav__container();
        right: 12px;
    }
</style>

<script>
    export default {
        name: "Expertise",
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            beforeEnterExpertiseContent : function(el)
            {
                el.style.opacity = 0;
                
                if (this.$parent._data.animationDirection === "right")
                {
                    el.style.left = "10%";
                }
                else 
                {
                    el.style.left = "90%";
                }

                el.querySelector(".expertise-content__cta").style.transform = "scale(0, 0)";
            },
            enterExpertiseContent : function(el, done)
            {
                TweenMax.to(el, 0.3, {left: "50%", opacity: 1, delay: 0.2});
                TweenMax.set(el, {className:"+=transform-anim", delay: 0.5});
                TweenMax.to(el.querySelector(".expertise-content__cta"), 0.8, {transform: "scale(1, 1)", delay: 1.2, ease: Back.easeOut.config(2), onComplete: done});
            },
            beforeEnterExpertiseButtons : function(el)
            {
                TweenMax.set(".expertise-btn-list__button", {opacity: 0});
            },
            enterExpertiseButtons : function(el, done)
            {
                var tl = new TimelineMax();
                tl.staggerTo(".expertise-btn-list__button", 0.7,  {transform: "scale(1)", ease: Back.easeOut.config(2), delay: 1}, 0.1);
                tl.staggerTo(".expertise-btn-list__button", 0, {className:"+=updown-anim"}, 0.15);
            },
            beforeEnterSideNavLeft :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(-110%)";
            },
            enterSideNavLeft: function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 0.8, transform : "translateX(0)", delay: 1.1});
            },
            beforeEnterSideNavRight :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(110%)";
            },
            enterSideNavRight : function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.1});
            },
            exploreClick: function()
            {
                this.$router.push("/expertise/explore");
            },
            goToExplore: function()
            {
                this.$router.push("/expertise/explore");
            }
        }
    };
</script>
